export const CI_MODE = 'cimode';
export const CI_MODE_ON = 'true';
export const CI_MODE_OFF = 'false';
